import React from 'react'

import { AnimatePresence } from 'motion/react'

import {
  CardOnboarded,
  type CardOnboardedAction,
  type CardOnboardedData,
  type CardOnboardedLabels,
  type CardOnboardedOptions,
  type CardOnboardedState,
  type CardOnboardedTimeFormat,
} from '@/components/molecules/CardOnboarded/CardOnboarded.tsx'
import { cn } from '@/lib/utils.ts'

export type CardListOnboardedTimeFormat = CardOnboardedTimeFormat

export type CardListOnboardedOptions = CardOnboardedOptions

export interface CardListOnboardedLabels extends CardOnboardedLabels {}

export type CardListOnboardedData = Array<CardOnboardedData & { id: string }>

export interface CardListOnboardedActions {
  onActivate: (requestId: string) => void
  onCancelRequest: (requestId: string, ...args: Parameters<CardOnboardedAction['onCancelRequest']>) => void
  onArrivedAtDestination: (
    requestId: string,
    ...args: Parameters<CardOnboardedAction['onArrivedAtDestination']>
  ) => void
}

export interface CardListOnboardedProps
  extends
    React.HtmlHTMLAttributes<HTMLDivElement>,
    CardListOnboardedTimeFormat,
    CardListOnboardedActions,
    Pick<CardOnboardedState, 'size'> {
  labels: CardListOnboardedLabels
  options: CardListOnboardedOptions
  data?: CardListOnboardedData
  state?: { active?: string; highlighted?: string }
}

export const CardListOnboarded = React.forwardRef<HTMLDivElement, CardListOnboardedProps>(
  (
    {
      className,
      labels,
      options,
      data = [],
      state,
      size,
      timeAgoFormatter,
      onActivate,
      onCancelRequest,
      onArrivedAtDestination,
      ...props
    },
    ref
  ) => (
    <div className={cn('flex flex-col', className)} ref={ref} {...props}>
      <AnimatePresence initial={false}>
        {data.map((card) => (
          <CardOnboarded
            {...card}
            key={card.id}
            labels={labels}
            options={options}
            size={size}
            timeAgoFormatter={timeAgoFormatter}
            state={state?.active === card.id ? 'active' : 'default'}
            highlighted={state?.highlighted === card.id}
            onClick={() => {
              onActivate(card.id)
            }}
            onCancelRequest={(value) => {
              onCancelRequest(card.id, value)
            }}
            onArrivedAtDestination={(...values) => {
              onArrivedAtDestination(card.id, ...values)
            }}
          />
        ))}
      </AnimatePresence>
    </div>
  )
)
